module.exports = __webpack_public_path__ + "img/fuera-de-servicio.a2a8e498.svg";